import './_navigation.scss';
import { useState } from "react";

const Navigation = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleClickOpenMenu = () => {
        setMenuOpen(prev => !prev);
    };

    return (
        <nav>
            <div className='navigation-burger' onClick={handleClickOpenMenu}>
                <div className={`burger ${menuOpen ? 'active-menu' : ''}`}>
                    <span />
                </div>
            </div>
            <ol className={`nav-links ${menuOpen ? 'active' : ''}`}>
                <li><a href='/shorts'>Courts-métrages</a></li>
                <li><a href='/audiobooks'>Livres audio</a></li>
                <li><a href='/musics'>Musiques</a></li>
                {/* <li><a href='/videos'>Vidéos</a></li> */}
                <li>
                    <ul>
                        <li>
                            <a href="https://www.instagram.com/arthur.lemeur/" target='_blank' rel="noopener noreferrer">
                                <img src='./assets/icons/instagram.svg' alt='Instagram link' />
                            </a>
                        </li>
                        <li>
                            <a href="mailto:arthurlemeur.music@gmail.com">
                                <img src='./assets/icons/mail-icon.svg' alt='Email' />
                            </a>
                        </li>
                    </ul>
                </li>
            </ol>
        </nav>
    );
};

export default Navigation;
